export const MAX_WORK_SHIFT_DURATION_HOURS = 7

export const MATRICULE_PREFIX = 'AGD'
